import DashboardIcon from './component.jsx'
export default DashboardIcon
